import React, { useRef } from "react";
import { connect } from "react-redux";
import { openRelated } from "../../../../redux/modal/action";
import { strings } from "../../../../util/data/strings";
import RelatedProduct from "../../../leaflet/RelatedProduct";
import Slider from "react-slick";
import { BREAKPOINT } from "../../../../helper/constant";

const Related = (props) => {
  const refCarousel = useRef(null);

  const handleRelatedClick = (code_id) => {
    props.openRelated(code_id);
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: BREAKPOINT.xl,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: BREAKPOINT.md,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: BREAKPOINT.xs,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <>
      <div className="row">
        <div
          className="col-12"
          style={{ background: "#dee2e6", textAlign: "center" }}
        >
          <span>
            {props.related.length > 0 ? strings.relatedProductsTitle : ""}
          </span>
        </div>
      </div>
      {props.related.length <= 6 ? (
        <div className="row">
          {props.related.map((el) => (
            <RelatedProduct
              key={el.skul}
              {...el}
              handleClick={handleRelatedClick}
            />
          ))}
        </div>
      ) : (
        <div className="container">
          <Slider ref={refCarousel} {...settings}>
            {props.related.map((el) => (
              <RelatedProduct
                isCarousel={true}
                key={el.skul}
                {...el}
                handleClick={handleRelatedClick}
              />
            ))}
          </Slider>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    modalRedux: state.modal
  };
};

export default connect(mapStateToProps, { openRelated })(Related);
